var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSampleFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8848 9.98V18.78C19.8848 19.9001 19.8848 20.4602 19.6668 20.888C19.4751 21.2643 19.1691 21.5703 18.7928 21.762C18.365 21.98 17.8049 21.98 16.6848 21.98H9.08477C7.96466 21.98 7.40461 21.98 6.97679 21.762C6.60046 21.5703 6.2945 21.2643 6.10276 20.888C5.88477 20.4602 5.88477 19.9001 5.88477 18.78V7.18C5.88477 6.05989 5.88477 5.49984 6.10276 5.07202C6.2945 4.69569 6.60046 4.38973 6.97679 4.19799C7.40461 3.98 7.96467 3.98 9.08477 3.98H13.8848M19.8848 9.98L13.8848 3.98M19.8848 9.98H14.8848C14.3325 9.98 13.8848 9.53228 13.8848 8.98V3.98",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSampleFile);
export default __webpack_public_path__ + "static/media/sample_file.3ea515b6066b30a3681ae69e850275e1.svg";
export { ForwardRef as ReactComponent };